import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

import { Box } from '@/components/Box';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Box)<{
  disableGutters?: boolean;
  variantColor: 'light' | 'dark';
}>`
  padding: 8px;
  position: relative;

  .swiper-button {
    &-prev,
    &-next {
      display: none;
    }

    &-prev.swiper-button-disabled,
    &-next.swiper-button-disabled {
      display: none;
    }
  }

  ${({ disableGutters, theme, variantColor }) => css`
    ${disableGutters &&
    css`
      ${theme.media.md.up} {
        padding-inline: 0;
      }
    `}

    ${theme.mediaQueries.md} {
      .swiper-button {
        &-prev,
        &-next {
          color: ${variantColor === 'light'
            ? theme.colors.white
            : theme.colors.black};
          display: initial;
          top: 45%;
          transform: translateY(-48%);

          ::after {
            font-size: 30px;
          }
        }

        &-prev {
          left: 0;
          text-align: left;
        }

        &-next {
          right: 0;
          text-align: right;
        }
      }
    }
  `}
`;

export const Title = styled(Typography)`
  text-transform: uppercase;
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.h4};
    padding-bottom: ${theme.spacing(3)};
  `}
`;

export const StyledSwiper = styled(Swiper)<{
  $hideNavigation: boolean;
  separator: string;
}>`
  ${({ theme }) => theme.media.md.up} {
    padding-inline: 15px;
  }
  .swiper {
    ${({ $hideNavigation }) => css`
      ${$hideNavigation &&
      css`
        &-button-prev,
        &-button-next {
          display: none;
        }
      `}
      &-slide {
        width: 64%;
        height: auto;
        ${({ theme }) => css`
          @media (min-width: ${theme.breakpoints.xs}) {
            width: 240px;
          }
        `}
      }
    `}
  }
`;
